import createUseValue from '@/utils/create-use-value';

export type Screen = 'welcome' | 'billing' | 'complete';

export const { useValue: useScreen, useValueActions: useScreenActions } =
  createUseValue<Screen>('welcome', 'screen');
